<template>
  <div class="changePwdBox">
    <div class="mask"></div>
    <div class="changePwdForm">
      <div class="header">
        <span class="title">修改密碼</span>
      </div>
      <div class="body">
        <div class="row">
          <div class="label">
            請輸入舊密碼 <span>*</span>
          </div>
          <div class="input">
            <el-input
              class="idBox"
              placeholder=""
              v-model="oldPassword"
              style="width: 2.50rem;"
              clearable>
            </el-input>
          </div>
        </div>
        <div class="row">
          <div class="label">
            請輸入新密碼 <span>*</span>
          </div>
          <div class="input">
            <el-input
              class="idBox"
              placeholder=""
              v-model="newPassword"
              style="width: 2.50rem;"
              clearable>
            </el-input>
          </div>
        </div>
        <div class="row">
          <div class="label">
            請再次輸入 <span>*</span>
          </div>
          <div class="input">
            <el-input
              class="idBox"
              placeholder=""
              v-model="confirmPassword"
              style="width: 2.50rem;"
              clearable>
            </el-input>
          </div>
        </div>
        <div class="btnGroup">
          <div class="submitBtn" @click="submit()">
            確認修改
          </div>
          <div class="cancelBtn" @click="$emit('closeChangePwdBox')">
            取消
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data()
  {
    return {
      // 舊密碼
      oldPassword: '',
      // 新密碼
      newPassword: '',
      // 確認密碼
      confirmPassword: ''
    }
  },
  methods: {
    //初始化數據的方法
    initData()
    {
      this.oldPassword = ''
      this.newPassword = ''
      this.confirmPassword = ''
    },
    //檢效新舊密碼是否壹致的方法
    checkPassword()
    {
      //判斷密碼長度
      if(this.newPassword.length < 6 || this.newPassword.length > 20)
      {
        this.$message({
          message: '密碼長度必須在6至20位之間',
          type: 'warning'
        })
        return false
      }

      if(this.newPassword !== this.confirmPassword)
      {
        this.$message({
          message: '兩次輸入的密碼不壹致',
          type: 'warning'
        })
        return false
      }
      return true
    },
    //校驗所有輸入框是否為空的方法
    checkInput()
    {
      if(this.oldPassword === '' || this.newPassword === '' || this.confirmPassword === '')
      {
        this.$message({
          message: '請填寫完整信息',
          type: 'warning'
        })
        return false
      }
      return true
    },
    //點擊確認修改按鈕的方法
    async submit()
    {
      //校驗輸入
      if(this.checkInput() && this.checkPassword())
      {
        let params = {
          password: this.oldPassword,
          //舊密碼
          new_password: this.newPassword,
          //新密碼
          new_password_confirm: this.confirmPassword,
        }

        //查詢用戶數據
        let res = await this.axios.post(this.IP + this.PATH + '/updatePassword', params)

        //接口不成功
        if(res.data.code !== 'SUCCESS')
        {
          this.$message.warning(res.data.message)
          return
        }

        //接口成功 清空數據
        this.initData()
        this.$message.success(`修改成功`)
        //關閉彈窗
        this.$emit('closeChangePwdBox')
        //退出登錄
        this.$emit('logout', {showTips: false})
      }
    },
  }
}
</script>
<style lang="less">
.changePwdBox {
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.5;
    z-index: 100;
  }

  .changePwdForm {
    transition: all .2s ease-in-out;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 0.125rem;
    z-index: 101;

    .header {
      height: 0.625rem;
      line-height: 0.625rem;
      padding: 0 0.3rem;

      .title {
        border-left: 0.05rem solid #1657da;
        padding-left: .1rem;
        font-size: 0.2rem;
        color: #333;
      }
    }

    .body {
      padding: 0.1rem 0.3rem .2rem;

      .row {
        display: flex;
        align-items: center;
        margin-bottom: 0.25rem;

        .label {
          width: 1.25rem;
          font-size: 0.16rem;

          span {
            color: red;
          }
        }
      }

      .btnGroup {
        display: flex;
        justify-content: center;
        margin-top: 0.4rem;

        .submitBtn {
          width: 1.25rem;
          height: 0.5rem;
          line-height: 0.5rem;
          text-align: center;
          font-size: 0.125rem;
          margin-right: 0.25rem;
          cursor: pointer;
          background-color: #1657da;
          border-radius: 0.13rem;
          color: white;
        }

        .cancelBtn {
          width: 1.25rem;
          height: 0.5rem;
          line-height: 0.5rem;
          text-align: center;
          border-radius: 0.125rem;
          font-size: 0.125rem;
          cursor: pointer;
          background-color: #e0e2e8;
          color: #757b89;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/change_pwd/index.vue